import React, { useState } from "react";
import { useSelector } from "react-redux";
import { CustomInput } from "reactstrap";

const SwitchComponent = ({ id, value, onAction, color = "#d70365" }) => {
  const { restaurantMedia } = useSelector((state) => state.restaurant);
  const [switchValue, setSwitchValue] = useState(value);
  const [isDisabled, setIsDisabled] = useState(false);

  const handleToggle = async () => {
    setIsDisabled(true);
    const result = await onAction(!switchValue);
    if (result) {
      setSwitchValue(!switchValue);
    }
    setIsDisabled(false);
  };

  return (
    <CustomInput
      type="switch"
      id={`customSwitch-${id}`}
      name={`customSwitch-${id}`}
      checked={switchValue}
      onChange={handleToggle}
      disabled={isDisabled}
      style={{
        "--track-checked": restaurantMedia?.adminColor || color,
        "--button-checked": "white"
      }}
    />
  );
};

export default SwitchComponent;
